export default __webpack_public_path__ + "static/media/placeholder_business04-nl-web.c8b5eb85.png";